import { Component, OnInit, NgZone, ViewChild } from '@angular/core';
import { Router, Event, NavigationEnd, UrlTree, UrlSegment, UrlSegmentGroup, PRIMARY_OUTLET } from '@angular/router';
import notify from 'devextreme/ui/notify';
import { ConfigService } from '../../services/config.service';
import { LanguageService } from '../../services/language.service';
import { UserService } from '../../services/user.service';
import { SettingsComponent } from '../printer/settings/settings.component';

export class NavMenu {
  moduleName: string;
  functionName: string;
  Name: string;
  MenuTypeId: number;
  URLOpenTypeId?: number;
  route?: string;

  module: string;
  function: string;

  moduleId: number;
  moduleFunctionId: number;
  disabled?: boolean;
  items?: NavMenu[];
  url?: string;
  icon?: string;
  beginGroup?: boolean;
  ParentMenuItems?: any[];

  constructor(menuItem: any = null, userId: string = null) {
    if (menuItem != null) {
      this.MenuTypeId = menuItem.MenuTypeId;
      this.URLOpenTypeId = menuItem.URLOpenTypeId;
      this.ParentMenuItems = menuItem.ParentMenuItems;
      this.functionName = menuItem.Name;
      this.Name = menuItem.Name;
      this.module = "";
      this.function = "";
      this.items = new Array<NavMenu>();
      this.icon = menuItem.Icon;
      this.route = menuItem.Route;

      this.moduleId = menuItem.ModuleId;
      this.moduleFunctionId = menuItem.ModuleFunctionId;

      //#1339 parameter-placeholders
      let moduleFunctionUrl: string = menuItem.URL;
      if (moduleFunctionUrl !== null) {
        if (moduleFunctionUrl.includes("@userid")) {
          moduleFunctionUrl = moduleFunctionUrl.replace("@userid", "userid=" + userId);
        }
      }
      this.url = moduleFunctionUrl;
    }
  }
}

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.css']
})
export class NavComponent implements OnInit {

  showFirstSubmenuModes: any;
  version: string = "";
  isValid: boolean = false;
  loadPanelVisible: boolean = false;

  mainMenuItems: Array<NavMenu>;

  //select printer stuff
  selectPrinterPopupVisible = false;
  selectPrinterPopupTitle = null;

  changePasswordPopupVisible = false;

  @ViewChild("thePrinterSetting") child: SettingsComponent;

  userMenuItems: NavMenu[] = [{
    moduleName: '',
    functionName: '',
    MenuTypeId: 0,
    URLOpenTypeId: null,
    Name: '',
    module: '',
    function: '',
    moduleId: -1,
    moduleFunctionId: -1,
    ParentMenuItems: [],
    items: [{
      moduleName: '',
      functionName: 'Sign out',
      MenuTypeId: 0,
      URLOpenTypeId: null,
      Name: 'Sign out',
      module: '/login',
      function: '',
      moduleId: -1,
      moduleFunctionId: -1,
      ParentMenuItems: [],
    }]
  }];

  navigationInfoClassPaddingLeft: string = "100px";//there is a variance in buttons to the left of the module and modulefunction name
  navigationInfoModule: string;
  navigationInfoFunction: string;
  separator: string;

  constructor(private configService: ConfigService, public userService: UserService, public router: Router, private zone: NgZone, private languageService: LanguageService) {
    this.showFirstSubmenuModes = {
      name: "onHover",
      delay: { show: 0, hide: 500 }
    };

    router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd && this.isValid) {
        if (!this.userHasAccess()) {
          this.navigationInfoModule = this.navigationInfoFunction = '';
          this.router.navigate(['/home']);
          return;
        }

        this.setNavigationInfo();
      }
    });
  }

  itemClick(data) {
    const item: NavMenu = data.itemData;
    if (item != null) {

      if (item.url != null && item.url.trim().length > 0 && item.URLOpenTypeId != null) {
        //update navigation text on top of screen
        let urlDisplayName = "";
        for (let i = 0; i < item.ParentMenuItems.length; i++) {
          urlDisplayName += item.ParentMenuItems[i].Name;
          if (i < (item.ParentMenuItems.length - 1)) {
            urlDisplayName += " - ";
          }
        }
        if (urlDisplayName.length > 0) {
          urlDisplayName = urlDisplayName + " | ";
        }
        else {
          urlDisplayName = "";
        }
        urlDisplayName += item.functionName;

        switch (item.URLOpenTypeId) {
          case URLOpenTypeEnum.NewTab:
            window.open(item.url, "_blank");
            break;
          case URLOpenTypeEnum.Iframe:
            this.zone.run(() => this.router.navigate(["external-viewer", "iframe-viewer"], { queryParams: { externalurl: item.url, displayName: urlDisplayName } }));
            break;
          case URLOpenTypeEnum.Dart:
            const theRoute: string[] = [];
            /*
             * the route is either e.g. "/admin/role-admin" or e.g. "dart-viewer" (or NULL)
             */
            if (item.route != null && item.route.trim().length > 0) {
              const route = item.route.split("/")
              if (route.length === 3) {
                theRoute.push(route[1]);
                theRoute.push(route[2]);
              }
              else {
                theRoute.push("external-viewer");
                theRoute.push(route[route.length - 1]);
              }
            }
            else {
              theRoute.push("external-viewer");
              theRoute.push("dart-viewer");
            }
            this.zone.run(() => this.router.navigate(theRoute, { queryParams: { externalurl: item.url, displayName: urlDisplayName } }));
            break;
          default:
            notify(`Unknown URLOpenTypeId: ${item.URLOpenTypeId}`, "error", 3000);
        }
      }
      else if (item.route != null && item.route.trim().length > 0) {
        const theRoute: string[] = [];
        const route = item.route.split("/")
        if (route.length === 3) {
          theRoute.push(route[1]);
          theRoute.push(route[2]);
        }
        else {
          theRoute.push(`/${route[route.length - 1]}`);
        }
        this.zone.run(() => this.router.navigate(theRoute));
      }
      else {
        //do nothing...(because there is no route or no URL to open)
        this.zone.run(() => this.router.navigate([""]));
      }
    }
  }

  userItemClick(data) {
    const item: NavMenu = data.itemData;
    if (item.module === '/login') {
      this.userService.logout();
    } else if (item.module === "/change-password") {
      this.changePasswordPopupVisible = true;
    } else if (item.module === '/time' && item.function === 'time-employee-balance') {
      this.navigationInfoModule = this.userService.account.FirstName + ' ' + this.userService.account.SurName;
      this.navigationInfoFunction = item.functionName;
      this.zone.run(() => this.router.navigate(['/time', 'employeebalance']));
    } else if (item.module === '/printer' && item.function === 'settings') {
      this.selectPrinterPopupVisible = true;

    } else if (item.module === '/select-company') {
      this.loadPanelVisible = true;
      this.userService.switchCompany(item.function)
        .subscribe((result: any) => { // success path
          if (result.IsSuccess) {
            this.userService.companyData(item.function);
            this.loadPanelVisible = false;
            location.reload();
          }
        }, error => { // error path;
          this.loadPanelVisible = false;
        });
    } else if (item.module === '/select-language') {
      this.loadPanelVisible = true;
      var rec = {
        "EmployeeId": this.userService.account.EmployeeId,
        "LanguageId": item.function
      };
      this.userService.switchLanguage(rec)
        .subscribe((result: any) => { // success path
          this.userService.languageData(result, item.function);
          this.loadPanelVisible = false;
          location.reload();
        }, error => { // error path;
          this.loadPanelVisible = false;
        });
    }
  }

  ngOnInit() {
  }

  initNav(valid: boolean) {
    this.version = this.configService.version?.directVersion;
    this.isValid = valid;
    this.setUserMenu();
    this.mainMenuItems = new Array<NavMenu>();

    if (valid) {
      const topMenuItems = this.userService.hierarchicalMenu;
      if (typeof (topMenuItems) !== "undefined" && topMenuItems != null) {
        for (let i = 0; i < topMenuItems.length; i++) {

          const menuItem = new NavMenu(topMenuItems[i], this.userService.userId);
          this.attachChildren(menuItem, topMenuItems[i].ChildMenuItems);
          this.mainMenuItems.push(menuItem);
        }
      }
    }
  }

  private attachChildren(menuItem: NavMenu, childMenuItems: any) {
    for (let j = 0; j < childMenuItems.length; j++) {
      const func = childMenuItems[j];
      const sub = new NavMenu(func, this.userService.userId);
      menuItem.items.push(sub);
      this.attachChildren(sub, func.ChildMenuItems);
    }
  }

  setUserMenu() {
    if (!this.isValid) {
      this.userMenuItems = [];
      return;
    }

    let account = this.userService.account;
    let companies = this.userService.companies;
    let languages = this.userService.languages;

    var items = [];

    items.push({
      moduleName: '',
      functionName: this.languageService.LNG('Label.Balance'),
      module: '/time',
      function: 'time-employee-balance',
      beginGroup: false
    });

    items.push({
      moduleName: '',
      functionName: this.languageService.LNG('Label.PrinterSettings'),
      module: '/printer',
      function: 'settings',
      beginGroup: false
    });

    var allowChangeCompany = false;
    if (account != null) {
      let value = account.SystemSettings['_34'];
      if (value !== undefined && value !== null) {
        let ids = value.split(';');
        if (ids !== null && ids.includes(account.EmployeeId.toString())) {
          allowChangeCompany = true;
        }
      }
    }
    if (companies != null && companies.length != 0 && allowChangeCompany) {
      var companyItems = [];
      for (let company of companies) {
        companyItems.push({
          moduleName: '',
          functionName: company.Name,
          module: '/select-company',
          function: company.CompanyId,
          beginGroup: false,
          icon: (company.CompanyId.toString() === this.userService.companyId ? 'todo' : '')
        });
      }

      items.push({
        moduleName: '',
        functionName: this.languageService.LNG('Label.Company'),
        module: '',
        function: '',
        beginGroup: false,
        items: companyItems
      });
    }

    const languageItems = [];
    if (languages != null) {
        for (var language of languages) {
        languageItems.push({
          moduleName: '',
          functionName: language.Description,
          module: '/select-language',
          function: language.LanguageId,
          beginGroup: false,
          icon: (language.LanguageId.toString() === this.userService.languageId ? 'todo' : '')
        });
      }
    }

    items.push({
      moduleName: '',
      functionName: this.languageService.LNG('Label.Language'),
      module: '',
      function: '',
      beginGroup: false,
      items: languageItems
    });
    if (!this.userService.isAzureAuthenticated) {
      items.push({
        moduleName: '',
        functionName: this.languageService.LNG('Label.Change.Password'),
        module: '/change-password',
        function: '',
        beginGroup: true,
        icon: 'key'
      });
    }
    items.push({
      moduleName: '',
      functionName: this.languageService.LNG('Label.Logout'),
      module: '/login',
      function: '',
      beginGroup: this.userService.isAzureAuthenticated,
      icon: 'export'
    });
    items.push({
      moduleName: '',
      functionName: `v.${this.version}`,
      module: '',
      function: '',
      beginGroup: true,
      icon: '',
      disabled: true
    });

    this.userMenuItems = [{
      moduleName: '',
      functionName: account.FirstName + ' ' + account.SurName,
      Name: account.FirstName + ' ' + account.SurName,
      module: '',
      function: '',
      MenuTypeId: 0,
      URLOpenTypeId: null,
      moduleId: 0,
      moduleFunctionId: 0,
      ParentMenuItems: [],
      items: items,
      icon: 'user'
    }];
  }


  userHasAccess(): boolean {
    const tree: UrlTree = this.router.parseUrl(this.router.url);
    const group: UrlSegmentGroup = tree.root.children[PRIMARY_OUTLET];
    const segments: UrlSegment[] = group.segments;

    //#1339
    if (segments != null && (segments.length === 1 || segments.length === 2)) {
    let theRoute = `/${segments[0].path}`;
      if (segments.length === 2) {
        theRoute += `/${segments[1].path}`;
      }
      for (let mf of this.userService.flatMenu) {
        if (mf.Route === theRoute) {
          return true;
        }
      }
    }

    //return false;
    return true; // Sjur: Need to redo this later. But for now we have to allow certain routes...
  }

  setNavigationInfo() {
    const tree: UrlTree = this.router.parseUrl(this.router.url);
    const group: UrlSegmentGroup = tree.root.children[PRIMARY_OUTLET];
    const segments: UrlSegment[] = group.segments;
    
    this.navigationInfoModule = '';
    this.navigationInfoFunction = '';

    if (tree.queryParams != null && typeof (tree.queryParams.displayName) !== "undefined") {
      this.navigationInfoModule = tree.queryParams.displayName;
    }
    else if (segments.length === 2 || segments.length === 1) {
      if (segments.length === 2 && segments[0].path == 'time' && segments[1].path === 'employeebalance') {
        this.navigationInfoModule = this.userService.account.FirstName + ' ' + this.userService.account.SurName;
        this.navigationInfoFunction = this.languageService.LNG('Label.Balance');
      }
      else if (segments.length === 2 && segments[0].path == 'printer' && segments[1].path === 'settings') {
        this.navigationInfoModule = this.userService.account.FirstName + ' ' + this.userService.account.SurName;
        this.navigationInfoFunction = this.languageService.LNG('Label.PrinterSettings');
      }
      else {
        let theRoute = `/${segments[0].path}`;
        if (segments.length === 2) {
          theRoute += `/${segments[1].path}`;
        }
        for (let mf of this.userService.hierarchicalMenu) {
          if (this.setNavigationInfoSearchMenu(mf, theRoute)) {
            break;
          }
        }
      }
    }
  }

  private setNavigationInfoSearchMenu(mf, theRoute: string): boolean {
    let found = false;
    if (mf.Route === theRoute) {
      found = true;

      this.navigationInfoClassPaddingLeft = "180px";
      let menuItemParentNames = "";
      for (let i = 0; i < mf.ParentMenuItems.length; i++) {
        menuItemParentNames += mf.ParentMenuItems[i].Name;
        if (i < (mf.ParentMenuItems.length - 1)) {
          menuItemParentNames += " - ";
        }
      }
      if (menuItemParentNames.length > 0) {
        this.navigationInfoModule = menuItemParentNames + " | ";
      }
      else {
        this.navigationInfoModule = "";
      }
      this.navigationInfoFunction = mf.Name;
    }
    else {
      for (let mfc of mf.ChildMenuItems) {
        if (this.setNavigationInfoSearchMenu(mfc, theRoute)) {
          break;
        }
      }
    }
    return found;
  }

  onLogout() {
    this.userService.logout();
  }

  selectPrinterPopupOnShowing(e) {
    if (this.child != null) {
      //load printer here because timing issue with loading data into the ConfigService
      this.child.setPrinterDataSource();
      if (this.child.gridComponent != null) {
        this.child.onRefresh();
      }
    }

  }

  selectPrinterPopupOnShown(e) {
    this.selectPrinterPopupTitle = `${this.languageService.LNG("Label.PrinterSettings")}: ${this.userService.account.Name}`;
  }
}

export enum URLOpenTypeEnum {
  NewTab = 1,
  Iframe = 2,
  Dart = 3
}
